import { render, staticRenderFns } from "./ExtraFieldsEditModal.vue?vue&type=template&id=82af15ec"
import script from "./ExtraFieldsEditModal.vue?vue&type=script&lang=ts"
export * from "./ExtraFieldsEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82af15ec')) {
      api.createRecord('82af15ec', component.options)
    } else {
      api.reload('82af15ec', component.options)
    }
    module.hot.accept("./ExtraFieldsEditModal.vue?vue&type=template&id=82af15ec", function () {
      api.rerender('82af15ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExtraFieldsEditModal.vue"
export default component.exports